
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
/**
 * 
 * @prop value      评论列表
 * @Emit content    查看评论详细内容
 * 
*/
@Component({})
export default class CommentsTable extends Vue {
    @Prop({ required: true }) private value!: []

    @Emit('content')
    private onLookDetail(comments: any) {
        // return comments.content
        return comments

    }
}
